// extracted by mini-css-extract-plugin
export default {"container":"task-sidebar_container__f1DeH"};